/** Signed-in portal user as resolved from the API (`GET /me`). */
export class UserModel {
  id: string | null = null;
  email = '';
  fullName = '';
  /** App role: Superuser | TenantAdmin | TenantUser (empty = no access). */
  role = '';
  tenantId: string | null = null;
  tenantName: string | null = null;
}
